import React, { useState } from "react";
import PropTypes from "prop-types";
import { Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import Grid from "@mui/material/Grid2";

// Soft UI Dashboard React components
import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import SuiInput from "components/SuiInput";
import SuiTypography from "components/SuiTypography";

const NuevoDocumentoAnexoModal = ({ open, onClose, onSubmit, docsExistentes }) => {
  const [tipo, setTipo] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = () => {
    const tipoNormalizado = tipo.trim().toUpperCase();

    if (!tipoNormalizado) {
      setError("Debe ingresar el Tipo de Documento Anexo.");
      return;
    }

    if (docsExistentes.some((e) => e.tipo.toUpperCase() === tipoNormalizado)) {
      setError("Ya existe un Documento Anexo de este Tipo");
      return;
    }

    onSubmit(tipoNormalizado);
    setTipo("");
    setError("");
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <SuiTypography variant="h6">Agregar Documento Anexo</SuiTypography>
      </DialogTitle>
      <DialogContent>
        <SuiBox py={1}>
          <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
            <Grid size={12}>
              <SuiTypography variant="h6" fontWeight="light">
                Tipo Documento
              </SuiTypography>
              <SuiInput
                autoFocus
                value={tipo}
                onChange={(e) => {
                  setTipo(e.target.value);
                  setError("");
                }}
                error={!!error}
                helperText={error}
                fullWidth
              />
              {error && (
                <SuiTypography
                  variant="caption"
                  textColor="error"
                  fontWeight="regular"
                  sx={{ mt: 1, display: "block" }}
                >
                  {error}
                </SuiTypography>
              )}
            </Grid>
          </Grid>
        </SuiBox>
      </DialogContent>
      <DialogActions>
        <SuiButton onClick={onClose} buttonColor="light">
          Cancelar
        </SuiButton>
        <SuiButton onClick={handleSubmit} variant="gradient" buttonColor="dark">
          Agregar
        </SuiButton>
      </DialogActions>
    </Dialog>
  );
};

NuevoDocumentoAnexoModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  docsExistentes: PropTypes.arrayOf(
    PropTypes.shape({
      tipo: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default NuevoDocumentoAnexoModal;
